__turbopack_context__.v({
  "container": "CQUSPq_container",
  "offsetLeft": "CQUSPq_offsetLeft",
  "offsetRight": "CQUSPq_offsetRight",
  "quote": "CQUSPq_quote",
});
